// extracted by mini-css-extract-plugin
export default {"editButton":"ActivityDetailsPage_editButton__uEz2D"};